import {relocateElementBySelector} from './util.js';
import {changePage} from './changePage.js';

/*
 * constructor
 * switch between tabbed and paged layouts
 */
export default function() {
  var transitionWidth = 940;
  var layout;

  // relocatable elements
  var elements = [
    {elem: '[data-ol-map]'     , tabbed: '[data-map-tab]'   ,      paged: '[data-map-page]'    },

    // redundant identifiers:
    // <div rwg-tab="side-legend" data-legend-tab id="legendTab" >
    // <div rwg-tab="side-info"   data-info-tab   id="infoTab" >
    // <div rwg-tab="side-draw"   data-draw-tab   id="drawTab" ></div>

    //{elem: '[data-info-div]', tabbed: '[data-info-tab]',      paged: '[data-info-page]'  },
     {elem: '[data-info-div]'   , tabbed: 'div[rwg-tab="side-info"]', paged: '[data-info-page]'  },

    // {elem: '[data-legend-div]', tabbed: '[data-legend-tab]',      paged: '[data-legend-page]' },
    {elem: '[data-legend-div]' , tabbed: 'div[rwg-tab="side-legend"]',      paged: '[data-legend-page]' },

    {elem: '[data-search-div]' , tabbed: '[data-search-tab]',      paged: '[data-search-page]' },
    {elem: '#container4toolbar', tabbed: '#mapTab'          ,      paged: '#mobile-toolbar-div'},
   // {elem: '#container4toolbar', tabbed: 'div[rwg-tab="top-map"]', paged: '#mobile-toolbar-div'},
  ];

  /**
   * @param {event|bool} force optional
   * usually called by eventListener but can be called directly
   * 'force' still shows up in tcwp
   */
  function set(arg) {
    let force = false;
    let evt = null;

    // arg is the event when called by window.eventListener['resize', 'pageshow']
    if (typeof arg === 'boolean') {
      force = arg;
      console.warn('agr == force')
    } else {
      evt = arg;
    }
    if (evt && evt.type === 'resize') {
      evt.stopImmediatePropagation();
      clearTimeout(rwg.map.updateSizeTimer);
      rwg.map.updateSizeTimer = setTimeout(function() {
        rwg.map.updateSize();
      }, 300);
    }

    if (window.innerWidth <= transitionWidth && (layout !== 'paged' || force)) {
      layout = 'paged';
      elements.forEach(e => {
        relocateElementBySelector(e.elem, e[layout]);
      });
      document.getElementById('search').style.display = 'block';  // I don't know why this is necessary
      changePage('mappage', 'replace');
    } else if (window.innerWidth > transitionWidth && (layout !== 'tabbed' || force)) {
      layout = 'tabbed';
      elements.forEach(e => {
        relocateElementBySelector(e.elem, e[layout]);
      });
      // switchTab(rwg.topTabs, 'search-tab'); // kluge to get search-div content hidden
      // switchTab(rwg.topTabs, 'map');
    } else {
      return;
    }
  }

  function get() {
    return layout;
  }

  function addElements(a) {
    if (Array.isArray(a)) {
      elements = elements.concat(a);
    } else {
      elements.push(a);
    }
    set(true);
  }

  // function getElements() {
  //   return elements;
  // }

  set();
  return {
    get: get,
    set: set,
    addElements: addElements,
    // below is pretty worthless because it won't match css
    // setTransitionWidth: w => transitionWidth = w,
  };
}
